
<template>
  <v-container fluid>
        <v-sparkline
      :value="value"
      :gradient="gradient"
      :smooth="radius || false"
      :padding="padding"
      :line-width="width"
      :stroke-linecap="lineCap"
      :gradient-direction="gradientDirection"
      :fill="fill"
      :type="type"
      :auto-line-width="autoLineWidth"
      auto-draw
    ></v-sparkline>

    <v-divider></v-divider>
  </v-container>
</template>

<script>
const gradients = [
  ['#222'],
  ['#42b3f4'],
  ['red', 'orange', 'yellow'],
  ['purple', 'violet'],
  ['#00c6ff', '#F0F', '#FF0'],
  ['#f72047', '#ffd200', '#1feaea'],
]

export default {
  name: "HelloWorld",
  // gradients: null,
  data() {
    return {
      width: 2,
      radius: 10,
      padding: 8,
      lineCap: 'round',
      gradient: gradients[5],
      value: [2, 3, 5, 9, 5, 10, 3, 5, 2, 1, 6, 10, 5, 9, 7, 1,0],
      gradientDirection: 'bottom',
      gradients,
      fill: false,
      type: 'trend',
      autoLineWidth: false,
    }
  }
}
</script>